export default ".fileInput {\n  font-size: 100px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 120px;\n  opacity: 0;\n}";